// @flow

import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { localize } from "redux-i18n";
import actionCreators from "@modules/service/actionCreator";
import * as serviceSelectors from "@modules/service/selectors";
import type { DynamicQuestionContent } from "@modules/service/reducer/dynamic-questions/types";
import AnswerOptionsForm from "../dynamic-question-answer-options/answer-options-form";
import { split } from "@transformers/schema";
import type { StepProps } from "@components";

type PropsFromState = $Exact<{
  draft: ?DynamicQuestionContent,
  schema: ?Object,
  isValid: boolean,
}>;

type PropsFromDispatch = $Exact<{
  onUpdateDraft: typeof actionCreators.UpdateDynamicQuestionDraft,
}>;

type Props = $Exact<{
  ...StepProps,
  ...PropsFromLocalize,
  ...PropsFromState,
  ...PropsFromDispatch,
}>;

export class AnswerOptions extends React.Component<Props> {
  answerOptionsSchema = split(this.props.schema, ["selectableValues"]);

  componentDidMount() {
    if (this.props.onChange) {
      this.props.onChange(this.props.draft || {}, this.props.isValid);
    }
  }

  updateDraft = (data: Array<string>) => ({
    ...this.props.draft,
    selectableValues: data,
  });

  handleChanges = (data: Array<string>) => {
    const updatedDraft = this.updateDraft(data);
    this.props.onUpdateDraft(updatedDraft);

    if (this.props.onChange) {
      this.props.onChange(updatedDraft, true);
    }
  };

  get data(): ?Array<string> {
    return this.props.draft ? this.props.draft.selectableValues : null;
  }

  render() {
    if (!this.props.editable) {
      return null;
    }
    return (
      <div className="w-100 d-flex justify-content-center">
        <div className="col-sm-12">
          <AnswerOptionsForm
            data={this.data}
            schema={this.answerOptionsSchema}
            onSubmit={this.handleChanges}
            onChange={this.handleChanges}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps): PropsFromState => {
  return {
    draft: serviceSelectors.getDynamicQuestionDraft(state),
    schema: serviceSelectors.getDynamicQuestionRevisionSchema(state),
    isValid: serviceSelectors.isDynamicQuestionDraftValid(state),
  };
};

const mapDispatchToProps: PropsFromDispatch = {
  onUpdateDraft: actionCreators.UpdateDynamicQuestionDraft,
};

export default compose(localize(), connect(mapStateToProps, mapDispatchToProps))(AnswerOptions);
